module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "app-footer"
  }, [_c('a', {
    attrs: {
      "href": "https://zeekdoc.com"
    }
  }, [_vm._v("Zeekdoc")]), _vm._v(" © 2017 Zeekdoc Co., Ltd,\n  \n")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74d0615a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/containerComponents/Footer.vue
// module id = 1035
// module chunks = 1